import React from 'react';
import no_result from './imgs/no_result.png';
import styles from './styles.module.scss';

const ResultNoResult = () => {
    return (
        <figure className={styles.figure}>
            <figcaption className={styles.figCaption}>
                <div className={styles.main}>
                    很抱歉，<span className={styles.noData}>沒有符合您查詢的資料</span>
                </div>
                <div className={styles.sub}>建議您在上方引擎搜尋其它目的地、出發區間</div>
            </figcaption>
            <img src={no_result} alt="無搜尋結果" className={styles.img} />
        </figure>
    );
};

export default ResultNoResult;
